<template>
  <div id="event">
    <!-- <div class="please-activate-event" v-if="isAttending == false">
      <h5>{{ $t("event.headerinfo.title") }}</h5>

      <p>
        <span
          >{{ $t("event.headerinfo.activation1") }} <a @click="$router.push({ name: 'home' })">{{ $t("event.headerinfo.activation2") }}</a> {{ $t("event.headerinfo.activation3") }}</span
        >
      </p>

      <p v-if="registrationFormUrls.length == 0">
        <span
          >{{ $t("event.headerinfo.contact1") }}<a :href="'mailto:' + currentEvent.organizator.email">{{ $t("event.headerinfo.contact2") }}</a
          >{{ $t("event.headerinfo.contact3") }}</span
        >
      </p>
      <p style="margin-top:0px;" v-else>
        <span>
          Aktivasyon kodunuz bulummuyor ise
          <el-dropdown>
            <span class="el-dropdown-link"><a href="javascript:;">buraya tıklayarak</a></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in registrationFormUrls" :key="item.id"
                ><a :href="item.url" target="_blank">{{ item.title }}</a></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          etkinliğe kayıt olabilirsiniz.
        </span>
      </p>
    </div> -->

    <div class="container">
      <img :src="$imageus + (currentEvent.image == null ? host + '/static/1120x500.png' : currentEvent.image) + '?width=1120&height=500)'" class="header" />
      <template v-if="windowWidth > 991">
        <div class="event-header">
          <div class="logo">
            <img :src="$imageus + (currentEvent.logo == null ? host + '/static/500x500.png' : currentEvent.logo) + '?width=200&height=200'" alt />
          </div>

          <div class="event-title">
            <h1>{{ currentEvent.title }}</h1>

            <span class="event-dates">
              <span>
                <i class="fas fa-calendar" :style="'color:' + currentEvent.color"></i>
                {{
                  moment(currentEvent.startDate)
                    .utc()
                    .format("DD MMMM YYYY") +
                    " " +
                    (currentEvent.startTime != null ? currentEvent.startTime : "") +
                    "&nbsp;"
                }}
              </span>
              <span>
                <i class="fas fa-long-arrow-alt-right" :style="'color:' + currentEvent.color"></i>
                {{
                  moment(currentEvent.endDate)
                    .utc()
                    .format("DD MMMM YYYY") +
                    " " +
                    (currentEvent.endTime != null ? currentEvent.endTime : "")
                }}
              </span>
              <span class="timezone">&nbsp;({{ currentEvent.timezone }})</span>
            </span>

            <span v-if="currentEvent.location != null && currentEvent.location.venue != null && currentEvent.location.venue != ''">
              <i class="fas fa-map-marker-alt" :style="'color:' + currentEvent.color"></i>
              {{ currentEvent.location.venue }}
            </span>
          </div>

          <template v-if="isAttending">
            <a
              class="add-to-calendar"
              :style="'background-color:' + currentEvent.color"
              :href="'https://www.google.com/calendar/event?action=TEMPLATE&text=' + currentEvent.title + '&dates=' + moment(currentEvent.startDate).format('YYYYMMDDTHHMM') + '/' + moment(currentEvent.endDate).format('YYYYMMDDTHHMM') + '&details=For+details,+go+here:%0A' + this.$route.query.page + '&location=' + (currentEvent.location != null ? currentEvent.location.venue : '') + ',+' + (currentEvent.location != null ? currentEvent.location.address : '') + '&trp=false&sprop=&sprop=name:'"
              target="_blank"
              rel="nofollow"
            >
              <span>
                <i class="fas fa-bookmark"></i>
                {{ $t("add_calendar") }}
              </span>
            </a>
          </template>

          <template v-else>
            <a class="add-to-calendar" v-if="registrationFormUrls.length == 0" :style="'background-color:' + currentEvent.color" :href="'mailto:' + currentEvent.organizator.email">
              <span>
                <i class="fas fa-envelope"></i>
                {{ $t("contact_us") }}
              </span>
            </a>
            <!-- <a class="add-to-calendar" v-else :style="'background-color:' + currentEvent.color" :href="'https://register.holacon.com/?ApplicationID=' + getApplication.id + '&EventID=' + currentEvent.id + '&language=' + $i18n.locale" target="_blank" rel="nofollow">
            <span><i class="fas fa-ticket-alt"></i>{{$t('register_and_buy_ticket')}}</span>
          </a> -->

            <el-dropdown v-else>
              <el-button type="primary">
                <i class="fas fa-ticket-alt"></i>
                {{ $t("register_and_buy_ticket") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in registrationFormUrls" :key="item.id">
                  <a :href="item.url" target="_blank">{{ item.title }}</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </div>
        <div class="event-content">
          <vue-page-transition name="fade-in-down">
            <router-view />
          </vue-page-transition>
        </div>
      </template>
      <template v-else>
        <div class="event-mobile-wrapper">
          <div class="mobile-section">
            <div class="mobile-event-header">
              <div class="event-infos">
                <div class="logo-box">
                  <img :src="$imageus + (currentEvent.logo == null ? host + '/static/500x500.png' : currentEvent.logo) + '?width=200&height=200'" alt />
                </div>
                <div class="mobile-event-title">
                  {{ currentEvent.title }}
                </div>
                <a
                  class="mobile-favorite-button"
                  target="_blank"
                  :href="'https://www.google.com/calendar/event?action=TEMPLATE&text=' + currentEvent.title + '&dates=' + moment(currentEvent.startDate).format('YYYYMMDDTHHMM') + '/' + moment(currentEvent.endDate).format('YYYYMMDDTHHMM') + '&details=For+details,+go+here:%0A' + this.$route.query.page + '&location=' + (currentEvent.location != null ? currentEvent.location.venue : '') + ',+' + (currentEvent.location != null ? currentEvent.location.address : '') + '&trp=false&sprop=&sprop=name:'"
                >
                  <i class="fas fa-bookmark"></i>
                </a>
              </div>
              <div class="event-dates-container">
                <div class="event-date">
                  <div class="date-icon-box">
                    <i class="fas fa-calendar"></i>
                  </div>
                  <span>
                    {{
                      moment(currentEvent.startDate)
                        .utc()
                        .format("DD MMMM")
                    }}
                  </span>
                  <i class="fas fa-long-arrow-alt-right"></i>
                  <span>
                    {{
                      moment(currentEvent.endDate)
                        .utc()
                        .format("DD MMMM, YYYY")
                    }}
                  </span>
                </div>
                <div class="event-date">
                  <div class="date-icon-box">
                    <i class="fas fa-clock"></i>
                  </div>
                  <span>{{ currentEvent.startTime != null ? currentEvent.startTime : "" }}</span>
                  <i class="fas fa-long-arrow-alt-right"></i>
                  <span>{{ currentEvent.endTime != null ? currentEvent.endTime : "" }}</span>
                </div>
                <div class="event-date">
                  <div class="date-icon-box">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                  <span v-if="currentEvent.location.venue != null && currentEvent.location.venue != ''">
                    {{ currentEvent.location.venue }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-section" v-if="moment(currentEvent.endDate) > moment(new Date()) && !isAttending">
            <div class="mobile-event-start">
              <div class="mobile-event-start-type">
                <i class="fas fa-video"></i>
                <span>{{ getEnumsDisplay("EventType", currentEvent.type) }}</span>
              </div>
              <div class="mobile-event-start-time-2">
                <span>{{ $t("eventDate.register") }}</span>
                <a class="add-to-calendar" v-if="registrationFormUrls.length == 0" :style="'background-color:' + currentEvent.color" :href="'mailto:' + currentEvent.organizator.email">
                  <span>
                    <i class="fas fa-envelope"></i>
                    {{ $t("contact_us") }}
                  </span>
                </a>
                <el-dropdown v-else>
                  <el-button type="primary">
                    <i class="fas fa-ticket-alt"></i>
                    {{ $t("register_and_buy_ticket") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in registrationFormUrls" :key="item.id">
                      <a :href="item.url" target="_blank">{{ item.title }}</a>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
          <div class="mobile-section">
            <div class="mobile-event-modules">
              <div class="module-item" v-for="(item, index) in currentEvent.modules.filter(x => x.name != 'SocialHub')" :key="item.name != null ? item.name + 'mobile-modules-' + index : item.title + 'mobile-modules-' + index" @click="goName(item)">
                <div class="module-icon">
                  <i v-if="item.name != null && loading != item.name && !item.isCustom" :style="($route.name == item.name ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/' + item.name.toLowerCase() + '.svg); background-color: ' + currentEvent.color + ';'"></i>
                  <i v-else-if="item.name != null && loading != item.name && item.isCustom" :style="($route.name == item.name ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/module.svg); background-color: ' + currentEvent.color + ';'"></i>
                  <i v-else class="el-icon-loading" :style="{ color: currentEvent.color }"></i>
                </div>
                <div class="module-title">
                  {{ $i18n.locale == "tr" ? item.titleTr : item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-section">
            <div class="mobile-section-title">
              <div class="section-icon">
                <i class="fas fa-info-circle" :style="{ color: currentEvent.color }"></i>
              </div>
              <div class="section-title">{{ $t("event.menu.about") }}</div>
            </div>
            <div class="mobile-about">
              <div class="about-text ql-container ql-editor ql-snow" v-html="currentEvent.about"></div>
            </div>
            <div v-if="currentEvent.location.longtitude != null && currentEvent.location.longtitude != ''">
              <GmapMap
                :center="{
                  lat: parseFloat(currentEvent.location.latitude),
                  lng: parseFloat(currentEvent.location.longtitude)
                }"
                :options="{
                  zoomControl: false,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: true,
                  disableDefaultUI: false,
                  draggable: false
                }"
                :zoom="14"
                map-type-id="terrain"
                style="position: relative; height: 169px; border-radius: 12px; overflow: hidden;"
              >
                <GmapMarker
                  :draggable="false"
                  :clickable="false"
                  :position="{
                    lat: parseFloat(currentEvent.location.latitude),
                    lng: parseFloat(currentEvent.location.longtitude)
                  }"
                />
              </GmapMap>
            </div>
            <div class="mobile-contact">
              <div class="mobile-contact-left">
                <a class="contact-area" v-if="currentEvent.organizator.phoneNumberIsActive && currentEvent.organizator.phoneNumber != null" :href="'tel:' + currentEvent.organizator.phoneNumber">
                  <i class="fas fa-phone-alt"></i>
                </a>
                <a class="cellPhone" v-if="currentEvent.organizator.mobilePhoneIsActive && currentEvent.organizator.mobilePhone != null" :href="'tel:' + currentEvent.organizator.mobilePhone">
                  <i class="fas fa-mobile"></i>
                </a>
                <a class="mail" v-if="currentEvent.organizator.emailIsActive && currentEvent.organizator.email != null" :href="'tel:' + currentEvent.organizator.email">
                  <i class="fas fa-envelope"></i>
                </a>
              </div>
              <div class="mobile-contact-right" v-if="currentEvent.location.longtitude != null && currentEvent.location.longtitude != ''">
                <el-button size="mini" type="primary" @click="googleMaps(currentEvent.location.latitude, currentEvent.location.longtitude)" round>{{ $t("directions") }}</el-button>
              </div>
            </div>
            <div class="social-bar-home">
              <div class="social-icon twitter" v-if="currentEvent.socialMedia.twitterIsACtive">
                <a :href="currentEvent.socialMedia.twitter" target="_blank">
                  <i class="fab fa-twitter"></i>
                </a>
              </div>

              <div class="social-icon linkedIn" v-if="currentEvent.socialMedia.linkedInIsActive">
                <a :href="currentEvent.socialMedia.linkedIn" target="_blank">
                  <i class="fab fa-linkedin"></i>
                </a>
              </div>

              <div class="social-icon facebook" v-if="currentEvent.socialMedia.facebookIsActive">
                <a :href="currentEvent.socialMedia.facebook" target="_blank">
                  <i class="fab fa-facebook"></i>
                </a>
              </div>

              <div class="social-icon instagram" v-if="currentEvent.socialMedia.instagramIsActive">
                <a :href="currentEvent.socialMedia.instagram" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>

              <div class="social-icon youtube" v-if="currentEvent.socialMedia.youtubeIsActive">
                <a :href="currentEvent.socialMedia.youtube" target="_blank">
                  <i class="fab fa-youtube"></i>
                </a>
              </div>

              <div class="social-icon website" v-if="currentEvent.socialMedia.websiteIsActive">
                <a :href="currentEvent.socialMedia.website" target="_blank">
                  <i class="fas fa-globe"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="mobile-section">
            <div class="mobile-hosted-by">
              <div class="logo-box">
                <img :src="$imageus + (currentOrganisation.image == null ? host + '/static/500x500.png' : currentOrganisation.image) + '?width=200&height=200'" alt />
              </div>
              <div class="organization-info">
                <span>Hosted by</span>
                <div class="title">{{ currentOrganisation.title }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="3dwrapper" v-html="htmlContent"></div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import $ from "jquery";
import axios from "axios";

export default {
  name: "Event",
  components: {},

  data() {
    return {
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      moment,
      swiperOption: {
        slidesPerView: "auto"
      },
      windowWidth: 0,
      loading: false,
      timeout: null,
      htmlContent: ""
    };
  },
  methods: {
    googleMaps(lat, long) {
      var latitude = parseFloat(lat);
      var longtitude = parseFloat(long);
      window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longtitude}`, "_blank");
    },
    goName(item) {
      this.loading = item.name;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!item.isCustom) {
          this.$router.push({ name: item.name }).catch({});
        } else {
          if (!item.url.includes("http://") && !item.url.includes("https://")) {
            item.url = "https://" + item.url;
          }
          window.open(item.url, "_blank");
        }
        this.loading = false;
      }, 500);
    }
  },
  created() {
    this.windowWidth = $(window).width();
    window.addEventListener("resize", event => {
      this.windowWidth = $(window).width();
    });
  },
  computed: {
    registrationFormUrls() {
      return this.$store.getters.getRegistrationFormUrls;
    },
    currentOrganisation() {
      return this.$store.getters.getOrganisation;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    isAttending() {
      return this.$store.getters.getAttending;
    },
    getApplication() {
      return this.$store.getters.getApplication;
    }
  }
};
</script>

<style lang="less">
#event {
  background-color: #f1f3f6;
  @media screen and (max-width: 991px) {
    background-color: unset !important;
  }
  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  margin-top: 55px;

  .please-activate-event {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0px 20px;

    h5 {
      font-size: 20px;
      font-weight: 500;
      margin: 16px 0px 0px 0px;
      color: #292f3b;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: #505763;

      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .container {
    display: unset;
    max-width: 1120px;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px;
    margin-bottom: 40px;
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    width: 100%;
    position: relative;
    @media screen and (max-width: 991px) {
      border-bottom-left-radius: unset !important;
      border-bottom-right-radius: unset !important;
    }
  }
  .header {
    width: 100%;
    max-width: 1120px;
    height: auto;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    @media screen and (max-width: 991px) {
      border-bottom-left-radius: unset !important;
      border-bottom-right-radius: unset !important;
    }
    margin-top: -14px;
  }

  .event-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 28px 20px;
    margin-bottom: 20px !important;
    margin-top: -22px !important;
    z-index: 2;
    @media screen and (max-width: 991px) {
      width: 100%;
      align-items: flex-start;
      flex-direction: column;
      justify-content: flex-start;
    }

    border-bottom: 1px solid #f1f3f6;

    .logo {
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
      width: 120px;
      height: 120px;
      aspect-ratio: 1;
      border-radius: 16px;
      background: rgb(236, 236, 236);
      cursor: default;
      margin-right: 1.25rem !important;

      img {
        border-radius: 16px;
      }
    }

    .event-title {
      margin-top: 20px;
      color: #292f3b !important;
      display: flex;
      flex: 1;
      flex-direction: column;
      max-width: calc(~"100% - 340px");
      & > .event-dates {
        span {
          &.timezone {
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: #268ea6;
          }
        }
      }
      h1 {
        margin: 0;
        font-weight: 700;
        font-size: 22px;
        color: #292f3b !important;
        letter-spacing: -0.015em;
        line-height: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      @media (max-width: 375px) {
        span {
          max-width: 240px;
        }
      }
      span {
        color: #505763;
        font-size: 14px;
        font-weight: 500;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;
        display: flex !important;
        margin-top: 3px;

        i {
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
          width: 16px;
          height: 16px;
          margin: 0;
          padding: 0;
          cursor: pointer;
        }
      }
    }

    .add-to-calendar {
      margin-top: 1.25rem;
      border: 0.5px solid #d6d9d9;
      border-radius: 8px;
      padding: 14px 28px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      cursor: pointer;
      text-decoration: none;

      span {
        font-size: 18px;
        color: #fff;
        font-weight: 500;
        i {
          font-size: 18px;
          margin-right: 7px;
        }
      }
    }
  }

  .event-content {
    padding: 0px 20px 20px 20px;

    .menu-box-disbled {
      opacity: 0.5;
      filter: grayscale(100%);
      cursor: not-allowed !important;
      cursor: no-drop !important;
    }

    .menu-box {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border: unset !important;

      cursor: pointer;

      &:first-child {
        margin-left: 0px;
      }

      .wrapper {
        justify-content: start;
        display: flex;
        align-items: center;
        flex-direction: column;
        flex: 1;
        display: flex;
        width: 100%;
        border-radius: 0px;
        text-decoration: none;

        .icon-container {
          border-radius: 8px;
          width: 50px;
          height: 50px;
          border: 0.5px solid #d6d9d9;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          text-decoration: none;

          i {
            font-size: 30px;
            margin-bottom: 0px;
            display: block;
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: contain;
            height: 30px;
            width: 30px;
            cursor: pointer;
            mask-repeat: no-repeat;
            mask-position: center;
          }
        }

        .title {
          color: #505763 !important;
          margin-top: 3px;
          font-size: 13px;
          max-height: 40px;
          overflow: hidden;
        }

        &.is-active {
          border-radius: 8px;
          i {
            color: #fff !important;
          }
          .title {
            color: #505763 !important;
            font-weight: 500;
            font-size: 13px;
          }
        }
      }

      .title {
        padding: 0px 10px;
        display: block;
        width: 100%;
        box-sizing: border-box;
        text-align: center;
      }
    }
  }

  .event-mobile-wrapper {
    padding: 1rem;
    padding-top: 0;
    margin-top: -1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .mobile-section {
      display: flex;
      flex-direction: column;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 16px;
      padding: 10px;
      gap: 1rem;
      .mobile-event-start {
        display: flex;
        gap: 1rem;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .mobile-event-start-type {
          background: #50bfbf;
          border: 2px solid #e8ebef;
          padding: 4px 8px;
          border-radius: 32px;
          display: flex;
          align-items: center;
          gap: 4px;
          color: white;
          & > i {
            font-size: 16px;
          }
          & > span {
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .mobile-event-start-line {
          height: 1px;
          width: 100%;
          background-color: #c8cdd3;
        }
        .mobile-event-start-time {
          &-2 {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
          }
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          letter-spacing: 0.4px;
          color: #292f3b;
        }
        .mobile-event-start-time-2 {
          display: flex;
          flex-direction: column;
          gap: 10px;
          justify-content: center;
          align-items: center;
        }
      }
      .mobile-about {
        display: flex;
        flex-direction: column;
        gap: 5px;
        .about-text {
          &.clamp {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            position: relative;
            &::before {
              position: absolute;
              display: block;
              background: linear-gradient(360deg, #ffffff 11.25%, rgba(255, 255, 255, 0) 100%);
              height: 50%;
              content: "";
              width: 100%;
              bottom: 0;
              left: 0;
              z-index: 2;
            }
          }
        }
        .read-mores {
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: #505763;
          cursor: pointer;
        }
      }
      .mobile-contact {
        padding-bottom: 1rem;
        border-bottom: 1px solid #c8cdd3;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        & > .mobile-contact-left {
          display: flex;
          gap: 10px;
          flex-direction: row;
          & > a {
            width: 28px;
            background: #268ea6;
            border-radius: 28px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            height: 28px;
          }
        }
        & > .mobile-contact-right {
          width: auto;
          & > .el-button {
            font-weight: bold !important;
          }
        }
      }
      .social-bar-home {
        margin: 0 !important;
      }
      .mobile-hosted-by {
        display: flex;
        gap: 10px;
        align-items: center;
        .logo-box {
          width: 56px;
          height: 56px;
          background: #f1f3f6;
          border: 3px solid #e8ebef;
          border-radius: 14px;
          overflow: hidden;
          flex-shrink: 0;
        }
        .organization-info {
          & > span {
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #505763;
          }
          & > .title {
            font-weight: 700;
            font-size: 16px;
            color: #292f3b;
            line-height: 20px;
          }
        }
      }
      .mobile-section-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        .section-icon {
          width: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 48px;
          border-radius: 50%;
          background: #f1f3f6;
          & > i {
            font-size: 24px;
          }
        }
        .section-title {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #292f3b;
        }
      }
      .mobile-event-modules {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .module-item {
          display: flex;
          gap: 10px;
          align-items: center;
          .module-icon {
            width: 48px;
            height: 48px;
            background: #f1f3f6;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            & > i {
              font-size: 30px;
              margin-bottom: 0px;
              display: block;
              background-position: 50%;
              background-repeat: no-repeat;
              background-size: contain;
              height: 30px;
              width: 30px;
              cursor: pointer;
              mask-repeat: no-repeat;
              mask-position: center;
            }
          }
          .module-title {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            display: flex;
            align-items: center;
            letter-spacing: 0.2px;
            color: #292f3b;
          }
        }
      }
      .mobile-event-header {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .event-infos {
          display: flex;
          align-items: center;
          gap: 10px;
          .logo-box {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            border: 3px solid #e8ebef;
            overflow: hidden;
            flex-shrink: 0;
          }
          .mobile-event-title {
            font-weight: 700;
            font-size: 18px;
            flex-grow: 1;
            line-height: 24px;
          }
          .mobile-favorite-button {
            width: 32px;
            height: 32px;
            flex-shrink: 0;
            background: #e8ebef;
            border-radius: 8px;
            display: flex;
            cursor: pointer;
            align-items: center;
            justify-content: center;
            & > i {
              color: #aaafb7;
              font-size: 18px;
            }
          }
        }
        .event-dates-container {
          display: flex;
          flex-direction: column;
          gap: 8px;
          .event-date {
            display: flex;
            gap: 6px;

            align-items: center;
            .date-icon-box {
              background: #f1f3f6;
              display: flex;
              color: #268ea6;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              width: 24px;
              height: 24px;
              font-size: 14px;
            }
            & > span {
              font-weight: 500;
              font-size: 14px;
              line-height: 18px;
            }
            & > i {
              color: #505763;
              font-size: 18px !important;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #event {
    padding: 0px;

    .container {
      margin-bottom: 0px;
      margin-top: 0px;
      padding-bottom: 40px;
      height: 100%;
      box-shadow: unset !important;
      -webkit-box-shadow: unset !important;
      background-color: transparent !important;
    }

    .header {
      height: auto !important;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }

    .event-header {
      padding: 0 6px 15px;
      margin-bottom: 20px !important;
      margin-top: -10px !important;

      .logo {
        width: 70px;
        height: 70px;
        margin-right: 0.8rem !important;
      }

      .event-title {
        margin-top: 20px;

        h1 {
          font-size: 16px;
          color: #292f3b !important;
          letter-spacing: -0.015em;
          line-height: 1;
        }

        span {
          font-size: 12px;
          margin-top: 0px;

          &.event-dates {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
          }

          & i {
            width: 12px;
            height: 12px;
          }
        }
      }

      .add-to-calendar {
        display: none;
      }
    }

    .event-content {
      padding: 0px 6px 20px 6px;

      .swiper-container {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        width: 100%;
        margin-bottom: 20px;

        .swiper-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 1;
          display: flex;
          transition-property: transform;
          box-sizing: content-box;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Event.vue